   
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import NotaService from   "@/service/v1/sigap/NotaService"  
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import Editar from   "./_Editar.vue"   
      
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "NotaShow",
        components: {  CardRh , KDataTable , Editar },   
    }) 
    export default class NotaShow extends Vue {
        
        @authStore.Getter
		public perfis!: any  

        @authStore.Getter
		public token!: any 
  
        public service = new NotaService(); 
        public model: any = null ;
        public turma: any = null ;
        public processando = false ; 
        public modal = 'modal_alterar_disciplina' ;
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
  
        created(){
            this.buscaNota();  
        }

        public statusAlterado(dados){ 
            this.buscaNota() ;
        }

        public modeloAlterado( ){ 
            this.buscaNota() ;
        }

        public buscaNota(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public excluirModelo(   ) {  
            SiteUtils.alertConfimacao('Confirma a Exclusão ','' , 
                () => {  
                    this.processando = true;  
                    setTimeout(() => {
                            this.service.excluir(  this.model.id   )
                        .then(response => {     
                            SiteUtils.toastSucesso('Exclusao realizada com sucesso!!' ); 
                            this.processando = false;
                            this.$router.push({ name: "sigap_avaliacao"  })
                            // this.$router.go(-1);
                        })
                        .catch(error => { 
                            this.processando = false; 
                            SiteUtils.toastErro('Não foi possivel Excluir ' , error.data.message); 
                        });  
                    }, 10); 
                }
            );   
        }  
 
    } 
